import { atom } from "recoil"

export const createMatchingOfferModeState = atom<"New" | "Edit">({
  key: "atoms/matching/create/createMatchingOfferModeState",
  default: "New",
})
